import React from "react";

import NoteType from "@mapmycustomers/shared/types/entity/common/Note";

import { formatDate } from "@app/util/formatters";
import isValidDate from "@app/util/isValidDate";
import { parseApiDate } from "@app/util/parsers";

import styles from "./Note.module.scss";

interface Props {
  note: NoteType;
}

const Note: React.FC<Props> = ({ note }) => {
  const date = parseApiDate(note.createdAt);
  return (
    <div className={styles.container}>
      <div className={styles.note}>{note.note}</div>
      {isValidDate(date) ? <div className={styles.date}>{formatDate(date, "Pp")}</div> : null}
    </div>
  );
};

export default Note;
